import type { DetailsPanelContentContributorsQuery } from '../queries/__types__/DetailsPanelContentContributorsQuery';

export const normalizeContentContributorsData = (data?: DetailsPanelContentContributorsQuery) => ({
	nodes: data?.contentContributors?.nodes ?? [],
});
